<template>
  <div class="footer">
    <div>© 2014 欧蒙医学诊断（中国）有限公司 京JCP备15005391号-1</div>
    <div class="footer-bottom">
      互联网药品新秀服务资格证书编号： （京） -非经营性-2015-0019 
      <img src="@/assets/badge.png">
      京公网安备 11010502031121号 法律申明
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
<style lang="scss" scoped>
.footer{
  // position: fixed;
  // bottom: 0;
  width: 100%;
  background: #000000;
  color: #666666;
  font-size: 0.75rem;
  border-top: 2px solid #07A903;
  padding: 1.76rem;
  z-index: 1000;

  &-bottom{
    margin-top: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img{
    height: 1rem;
    width: 1rem;
    margin: 0 0.5rem;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Footer.vue